import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBrain } from "@fortawesome/free-solid-svg-icons";

import { useLanguage } from "../../../context/LanguageProvider";
import { ROUTES } from "../../../shared/constants/routes";
import ResponsiveImage from "../../../shared/components/elements/ResponsiveImage";

import type { Course } from "../types";
import { getDifficultyLabel } from "../../../shared/constants/courseContent";

interface CourseCardProps {
    course: Course;
}

// Card in the course list. The whole card is the link.
const CourseCard = ({ course }: CourseCardProps) => {
    const { lang } = useLanguage();
    const difficulty = getDifficultyLabel(course.difficulty);

    return (
        <Link
            to={ROUTES.course(lang, course.id)}
            className="w-full p-0 md:w-1/2 lg:w-1/3 md:p-3"
        >
            <div className="transition hover:-translate-y-3 border-2 border-gray-200 shadow-sm cursor-pointer rounded-2xl overflow-hidden">
                <div className="relative">
                    <ResponsiveImage
                        src={course.image}
                        alt={course.title}
                        className="w-full rounded-md h-32 lg:h-64 object-cover"
                    />

                    {difficulty && (
                        <div className="absolute bottom-2 left-2 bg-white/90 text-gray-800 text-sm px-3 py-1 rounded-full flex items-center gap-1 shadow">
                            <span>{difficulty}</span>
                            <FontAwesomeIcon icon={faBrain} />
                        </div>
                    )}
                </div>

                <div className="py-8 px-6">
                    <h2 className="text-xl line-clamp-2 leading-relaxed font-bold">
                        {course.title}
                    </h2>

                    {course.category && (
                        <span className="text-md mt-2 block text-gray-700">{course.category}</span>
                    )}
                </div>
            </div>
        </Link>
    );
};

export default CourseCard;